import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { PRESS_MAILTO_HREF } from '#src/app/pages/about/press/shared/consts';
import type { CtaLink } from '#src/app/pages/about/shared/components';
import { ClosingCta } from '#src/app/pages/about/shared/components';

const CONTACT_LINK: CtaLink = {
	href: PRESS_MAILTO_HREF,
	label: translationKey('corgi.press_page.cta.contact'),
	dataQa: 'press-cta-contact',
};

const ABOUT_LINK: CtaLink = {
	href: '/about',
	label: translationKey('corgi.press_page.cta.about'),
	dataQa: 'press-cta-about',
};

export const PressCta: React.FC<EmptyProps> = () => {
	return (
		<ClosingCta
			heading={translationKey('corgi.press_page.cta.heading')}
			body={translationKey('corgi.press_page.cta.body')}
			primary={CONTACT_LINK}
			secondary={ABOUT_LINK}
		/>
	);
};
